import { render } from "./DeatilsImage.vue?vue&type=template&id=73bc08a6"
import script from "./DeatilsImage.vue?vue&type=script&lang=js"
export * from "./DeatilsImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__